import {
  Directive,
  Input,
  HostBinding,
  ElementRef
} from '@angular/core';

@Directive({
  selector: '[bui-th]'
})
export class DataThDirective {
  _el: HTMLElement;
  @Input() @HostBinding(`class.ant-table-selection-column`) checkbox: boolean;

  constructor(private _elementRef: ElementRef) {
    this._el = this._elementRef.nativeElement;
  }
}
